export default __webpack_public_path__ + "static/media/35d7751a12cb806f43007a8b113b18cd.svg";